<template>
  <b-dropdown
    no-caret
    right
    variant="link"
    class="avenir-medium"
    id="dropdown-options-chat"
  >
    <template #button-content>
      {{ $t('ia.chat.actions') }}
      <feather-icon icon="ChevronDownIcon" />
    </template>
    
    <!-- Text message actions -->
    <div v-if="!messageType">
      <b-dropdown-item 
        v-for="action in actions" 
        :key="action.value" 
        @click="$emit('action', action.value)"
        :disabled="!canUseAction"
      >
        <div class="d-flex justify-content-between">
          {{ action.text }} 
          <span class="icon-ia-actions">
            {{ actionCreditsDisplay }} 
            <feather-icon icon="CodesandboxIcon" class="icon-ia" />
          </span>
        </div> 
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="$emit('export')">
        {{ $t('tracking.export') }}
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="$emit('generate-image')">
        <div class="d-flex">
          <div>{{ $t('ia.chat.generateImages') }}</div>
          <div class="d-flex justify-content-between">
            <span class="icon-ia-actions">
              {{ imageCreditsDisplay }} 
              <feather-icon icon="CodesandboxIcon" class="icon-ia" />
            </span>
          </div> 
        </div>
      </b-dropdown-item>
    </div>
    
    <!-- Image message actions -->
    <div v-else>
      <b-dropdown-item @click="$emit('download-all')">
        {{ $t('ia.chat.downloadAll') }}
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('generate-more')" :disabled="!hasOriginalMessage">
        <div class="d-flex justify-content-between">
          {{ $t('ia.chat.generateAdditionalImages') }}
          <span class="icon-ia-actions">
            {{ imageCreditsDisplay }} 
            <feather-icon icon="CodesandboxIcon" class="icon-ia" />
          </span>
        </div> 
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';

export default {
  name: 'ChatMessageActions',
  components: { BDropdown, BDropdownItem, BDropdownDivider },
  props: {
    messageType: { type: String, default: null },
    hasOriginalMessage: { type: Boolean, default: false },
    actions: { type: Array, required: true },
    credits: { type: Object, default: () => ({}) },
    canUseAction: { type: Boolean, default: true }
  },
  computed: {
    actionCreditsDisplay() {
      return this.credits.actions >= 0 ? this.credits.actions : this.$t('ia.general.insufficientCredits');
    },
    imageCreditsDisplay() {
      return this.credits.images >= 0 ? this.credits.images : this.$t('ia.general.insufficientCredits');
    }
  }
}
</script>

<style lang="scss">
#dropdown-options-chat {
  .btn {
    padding: 0 !important;
    color: black;
  }
  .icon-ia-actions {
    margin-left: 1.5em;
    color: #5582f6;
    .icon-ia {
      width: 17px;
      height: 17px;
    }
  }
}
</style>
